// @flow
import React, { type Node } from 'react';
import classNames from 'classnames';

import styles from './HeaderLvl3.module.scss';;


type Props = {
  children: Node,
  className?: string,
}

const HeaderLvl3 = ({ children, className }: Props) => (
  <h2 className={classNames(styles.root, className)}>
    {children}
  </h2>
);

export default HeaderLvl3;
